import React from 'react'
import { format } from 'date-fns'

const GetInfoRow = (props: { text: string; subText: string }) => (
  <div className='flex items-center gap-[6px]'>
    <div className='text-[#001A3D] text-xs md:text-lg font-medium md:font-bold'>
      {props.text}
    </div>

    <div className='text-[#25395C] text-[10px] md:text-base'>
      {props.subText}
    </div>
  </div>
)

export const ArticleInfo = (props: {
  name: string
  publishDate: string
  updatedDate: string
}) => (
  <div className='flex flex-col items-start gap-2'>
    <GetInfoRow text='Author name:' subText={props.name} />
    <GetInfoRow
      text='Date published:'
      subText={format(new Date(props.publishDate), 'do MMMM yyyy')}
    />
    <GetInfoRow
      text='Date updated:'
      subText={format(new Date(props.updatedDate), 'do MMMM yyyy')}
    />
  </div>
)
